
const rawBaseUrl = (process.env.VUE_APP_API_BASE_URL || '').trim().replace(/\/$/, '')

function normalizePath(path = '') {
  if (!path) {
    return '/api'
  }

  if (/^https?:\/\//i.test(path)) {
    return path
  }

  const normalized = path.startsWith('/') ? path : `/${path}`
  return normalized.startsWith('/api/') || normalized === '/api'
    ? normalized
    : `/api${normalized}`
}

export function buildApiUrl(path = '') {
  const normalizedPath = normalizePath(path)
  if (/^https?:\/\//i.test(normalizedPath)) {
    return normalizedPath
  }

  return rawBaseUrl ? `${rawBaseUrl}${normalizedPath}` : normalizedPath
}

export const API_BASE_URL = rawBaseUrl || '/api'
